export function getLabelForLegendItem(legendItem, i18n) {
    const label = legendItem.label;
    if (typeof label === 'string')
        return label;
    return i18n.translatable(label);
}
